import app from './../app.js';  
import config from './../config.js';  
import Base_layers_class from './../core/base-layers.js';  
import { Base_action } from './base.js';  
export class Toggle_layer_lock_action extends Base_action 
{   
    constructor(layer_id) 
  {  
       super('toggle_layer_lock', 'Toggle Layer Lock');  
        this.layer_id = layer_id;  
        this.old_locked = null;  
    }  
  
    async do() {  
        super.do();  
        const Base_layers = new Base_layers_class();  
        const layer = Base_layers.get_layer(this.layer_id);  
          
        if (!layer) return;  
          
        this.old_locked = layer.locked;  
        layer.locked = !layer.locked;  
          
        app.Layers.render();  
        app.GUI.GUI_layers.render_layers();  
    }  
  
    async undo() {  
      super.undo(); 
        super.undo();  
        const Base_layers = new Base_layers_class();  
        const layer = Base_layers.get_layer(this.layer_id);  
          
        if (!layer) return;  
          
        layer.locked = this.old_locked;  
          
        app.Layers.render();  
        app.GUI.GUI_layers.render_layers();  
    }  
}  
  
export default Toggle_layer_lock_action;